<template>
  <div class="cpm-wrapper">
    <el-dialog title="随货资质需求" :visible.sync="dialogVisible" width="490px" :close-on-click-modal="false">
      <div class="cpm-content">
        <div class="store-wrapper">
          <img
            class="logo"
            v-if="certificationMerchantItemInfos.shopIcon"
            :src="certificationMerchantItemInfos.shopIcon + '?x-oss-process=image/resize,w_72/quality,q_90'"
            alt=""
          />
          <img class="logo" v-else :src="require('@/assets/img/shop-logo.png')" alt="" />
          <span class="store-name">
            {{ certificationMerchantItemInfos.shopName }}&nbsp;&nbsp;&nbsp;&nbsp;{{
              certificationMerchantItemInfos.merchantEntityName
            }}
          </span>
        </div>
        <div class="sub-tittle">企业相关资质</div>
        <!-- <ChooseTab
          :tabList="certificationTypeOptions"
          itemClass="chooseItemCls"
          :activeVal="certificationType"
          @change="onPayTypeChange"
        /> -->
        <div class="list">
          <span
            :key="index"
            @click="chooseShop(item)"
            :class="`tab-item chooseItemCls ${selectedShopCerti.indexOf(item) > -1 ? 'active' : ''}`"
            v-for="(item, index) in shopCerti"
          >
            {{ item }}
          </span>
        </div>
        <div class="sub-tittle">
          商品相关资质
          <span class="info">（药检报告默认随货）</span>
        </div>
        <div class="certification-wrapper">
          <div
            :key="index"
            v-for="(item, index) in (certificationMerchantItemInfos.itemList || []).slice(
              (fontCurrentPage - 1) * 5,
              fontCurrentPage * 5
            )"
            class="goods-wrapper"
          >
            <img class="goods-img" v-if="item.itemThumbnail" :src="item.itemThumbnail" alt="" />
            <img class="goods-img" v-else :src="require('@/assets/img/goods-empty.png')" alt="" />
            <div class="goods-info">
              <div class="goods-title">{{ item.itemName }} {{ item.spec }}</div>
              <div class="goods-certification">
                <el-checkbox v-model="item.drugReport" disabled label="检验报告"></el-checkbox>
                <el-checkbox v-model="item.sellQualification" label="首营资料"></el-checkbox>
              </div>
            </div>
          </div>
          <el-pagination
            v-show="(certificationMerchantItemInfos.itemList || []).length > 5"
            @current-change="handleCurrentChange"
            :page-size="5"
            layout=" prev, pager,next"
            :total="(certificationMerchantItemInfos.itemList || []).length"
          ></el-pagination>
        </div>
      </div>
      <div slot="footer" style="textalign: right">
        <el-button style="border-radius: 0" @click="onCancel">取消</el-button>
        <el-button style="border-radius: 0" type="primary" @click="onSubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { cloneDeep } from 'lodash';
import { mapState, mapActions } from 'vuex';
export default {
  components: {},
  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState('order', ['preOrderInfo'])
  },
  watch: {
    dialogVisible: {
      handler(val) {
        if (val) {
          this.certificationMerchantItemInfos = this.info;
          this.selectedShopCerti = [];
          this.copyInfo = cloneDeep(this.preOrderInfo);
          const copyPreOrderInfo = this.preOrderInfo;
          copyPreOrderInfo.merchantItemInfos.map((item) => {
            if (item.shopId === this.certificationMerchantItemInfos.shopId) {
              this.selectedShopCerti = item.merchantQualifications ? item.merchantQualifications : [];
            }
          });
        }
      }
    }
  },
  mounted() {
    this.certificationMerchantItemInfos = this.info;
  },
  data() {
    return {
      certificationMerchantItemInfos: {
        followGoodsCertification: []
      },
      fontCurrentPage: 1,
      dialogVisible: false,
      selectedShopCerti: [],
      shopCerti: ['企业首营资料', '购售合同', '18年度报告', '19年度报告', '20年度报告']
    };
  },
  methods: {
    ...mapActions('order', ['setPreOrderInfo']),
    handleCurrentChange(val) {
      this.fontCurrentPage = val;
    },
    onSubmit() {
      const copyPreOrderInfo = cloneDeep(this.preOrderInfo);
      copyPreOrderInfo.merchantItemInfos.map((item) => {
        if (item.shopId === this.certificationMerchantItemInfos.shopId) {
          item.itemList = this.certificationMerchantItemInfos.itemList;
          item.merchantQualifications = this.selectedShopCerti;
        }
      });
      this.setPreOrderInfo(copyPreOrderInfo);

      this.dialogVisible = false;
    },
    onCancel() {
      this.setPreOrderInfo(this.copyInfo);
      this.dialogVisible = false;
      this.$emit('cancel');
    },
    chooseShop(string) {
      let copy = cloneDeep(this.selectedShopCerti);
      if (copy.indexOf(string) > -1) {
        const existIndex = copy.indexOf(string);
        if (existIndex > -1) {
          copy.splice(existIndex, 1);
        }
      } else {
        copy.push(string);
      }
      this.selectedShopCerti = copy;
    },
    handleCheckedCitiesChange() {}
  }
};
</script>

<style lang="scss" scoped>
.cpm-wrapper {
  .cpm-content {
    .sub-tittle {
      font-size: 12px;
      font-weight: 400;
      color: #333333;
      margin-top: 16px;
      margin-bottom: 8px;
      .info {
        color: #8c8c8c;
      }
    }
    .list {
      .tab-item {
        width: 184px;
        height: 32px;
        font-size: 12px;
        border: 1px dashed #dedede;
        line-height: 32px;
        text-align: center;
        display: inline-block;
        margin-right: 8px;
        cursor: pointer;
        background: #fafafa;
      }
      .active {
        color: #1e8dff;
        border: 1px solid #1e8dff;
        background: #fff url('../../../assets/img/trian-right-icon.png') right bottom no-repeat;
        background-size: 17px 17px;
      }
    }
    ::v-deep .chooseItemCls {
      display: inline-block;
      height: 28px;
      line-height: 28px;
      width: auto;
      padding: 0 16px;
      margin-bottom: 8px;
    }
    .store-wrapper {
      display: flex;
      align-items: center;
      .logo {
        width: 30px;
        height: 30px;
      }
      .store-name {
        margin-left: 8px;
        font-size: 12px;
        font-weight: 400;
        color: #333333;
      }
    }
    .goods-wrapper {
      display: flex;
      align-items: center;
      .goods-img {
        width: 30px;
        height: 30px;
        margin-right: 8px;
      }
      .goods-info {
        flex: 1;
        font-size: 12px;
        font-weight: 400;
        color: #333333;
        ::v-deep .el-checkbox__label {
          font-size: 12px;
          font-weight: 400;
        }
      }
    }
  }
  .el-pagination {
    text-align: right;
  }
}
</style>
